








import { Vue, Component, Prop } from 'vue-property-decorator';
import UIModule from '@/store/modules/ui';

@Component({
  components: {
  },
})
export default class Pane extends Vue {
  @Prop({}) title!: string;

  get pane() {
    return UIModule.pane;
  }

  set pane(v) {
    UIModule.SET_PANE(v);
  }

  togglePane() {
    this.pane = !this.pane;
  }
}
